// Dashboard-Raster (design_handoff_dashboard §2) und Begrüßung. Reine Funktionen, getestet.

export type RasterStufe = 'wide' | 'mid' | 'schmal';

/** Stufe aus der echten Fensterbreite (mobil < 900) und der gemessenen Breite der Dashboard-Fläche. */
export function rasterStufe(verfuegbar: number, fenster: number): RasterStufe {
  if (fenster < 900) return 'schmal';
  if (verfuegbar >= 1100) return 'wide';
  if (verfuegbar >= 560) return 'mid';
  return 'schmal';
}

export type WidgetSchluessel =
  | 'briefing' | 'kpi' | 'arbeit' | 'pruef' | 'auslastung' | 'mail' | 'woche' | 'tickets' | 'rechnungen' | 'offen' | 'aktivitaeten';

/**
 * Spaltenbreite (von 12) je Widget. „auslastung“ = Stapel Auslastung + Schnellzugriff, „woche“ = Stapel Diese Woche +
 * Termine. Team-Rolle (nurEigene): Auslastung, Woche, Termine, Aktivitäten entfallen im Code – E-Mail volle Breite,
 * in der mittleren Stufe Prüfungen und Schnellzugriff je volle Breite.
 */
export function spalten(stufe: RasterStufe, nurEigene: boolean, verfuegbar: number): Record<WidgetSchluessel, number> {
  if (stufe === 'wide') {
    return { briefing: 6, kpi: 2, arbeit: 5, pruef: 4, auslastung: 3, mail: nurEigene ? 12 : 8, woche: 4, tickets: 4, rechnungen: 4, offen: 4, aktivitaeten: 12 };
  }
  if (stufe === 'mid') {
    return {
      briefing: 12, kpi: verfuegbar >= 520 ? 4 : 12, arbeit: 12, pruef: nurEigene ? 12 : 6, auslastung: nurEigene ? 12 : 6,
      mail: 12, woche: 12, tickets: 6, rechnungen: 6, offen: 12, aktivitaeten: 12,
    };
  }
  return { briefing: 12, kpi: 12, arbeit: 12, pruef: 12, auslastung: 12, mail: 12, woche: 12, tickets: 12, rechnungen: 12, offen: 12, aktivitaeten: 12 };
}

/** Begrüßung nach Uhrzeit wie bisher: < 12 „Guten Morgen“, < 18 „Guten Tag“, sonst „Guten Abend“ + Vorname. */
export function begruessung(stunde: number, vollerName: string | null | undefined): string {
  const name = vollerName?.split(' ')[0] || '';
  const gruss = stunde < 12 ? 'Guten Morgen' : stunde < 18 ? 'Guten Tag' : 'Guten Abend';
  return `${gruss}${name ? ', ' + name : ''}`;
}
